import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchPublicCmsData } from "../api/cmsApi";
import { listJobCategories, listJobs } from "../data/cmsStore";

export default function CareersPage() {
  const [jobs, setJobs] = useState(() => listJobs().filter((j) => j.status === "open"));
  const [categories, setCategories] = useState(() => listJobCategories());
  useEffect(() => {
    (async () => {
      try {
        const data = await fetchPublicCmsData();
        if (Array.isArray(data.jobs) && data.jobs.length) {
          setJobs(data.jobs.filter((j) => j.status === "open"));
        }
        if (Array.isArray(data.jobCategories) && data.jobCategories.length) {
          setCategories(data.jobCategories);
        }
      } catch (_) {
        // Keep local fallback data if API is unreachable.
      }
    })();
  }, []);
  const catName = (id) => categories.find((c) => c.id === id)?.name || "";

  return (
    <div className="cms-public-page">
      <section className="cms-hero animate-on-scroll">
        <div className="container">
          <span className="cms-label">Careers</span>
          <h1>Join Emicron</h1>
          <p>Build cloud, security, and managed IT solutions with a growing technology team.</p>
        </div>
      </section>
      <section className="cms-section animate-on-scroll">
        <div className="container">
          <div className="cms-job-list">
            {jobs.map((job) => (
              <article key={job.id} className="cms-job-card">
                <div>
                  <span className="cms-chip">{catName(job.categoryId)}</span>
                  <h2><Link to={`/careers/${job.slug}`}>{job.title}</Link></h2>
                  <p>{job.description.slice(0, 140)}…</p>
                  <div className="cms-meta">{job.location} · {job.type} · {job.experience}{job.salary ? ` · ${job.salary}` : ""}</div>
                </div>
                <Link to={`/careers/${job.slug}`} className="cms-btn">Apply</Link>
              </article>
            ))}
            {jobs.length === 0 ? <p className="cms-empty">No open positions right now.</p> : null}
          </div>
        </div>
      </section>
    </div>
  );
}
